import style from "./style.module.scss";
import Circle from "../../InfoPages/PageContent/Common/Circle";


export default function PinkSlogan({ style: pstyle }) {
    return <div className={style.pinkSlogan}>
        {/* <Circle /> */}
        <div className={style.content}>
            <div className={style.slogan}>
                BESTE MENSEN <br />
                U zal alles gezien hebben,bij U thuis,voor uw vertrek.<br />
                Op voorhand beter en vollediger op de hoogte zijn is onmogelijk.<br />
                Kom kijken,u gaat thuiskomen!
            </div>

            <div className={pstyle.link + " " + style.link}>
                Uw favoriete vastgoed staat te springen om U te leren kennen.
            </div>
        </div>
    </div>
}